'use client'

import { FormItem } from '@/shared/form/FormItem'
import { Input } from '@/shared/form/Input'

interface ForgotPasswordFieldsProps {
  inputClassName?: string
}

export const ForgotPasswordFields = ({
  inputClassName = ''
}: ForgotPasswordFieldsProps) => {
  return (
    <FormItem name="email" vertical>
      <FormItem.Label>E-mail</FormItem.Label>
      <FormItem.Control>
        <Input
          name="email"
          type="email"
          autoComplete="email"
          className={inputClassName}
        />
      </FormItem.Control>
    </FormItem>
  )
}
